{
  "name": "snapmatic-frontend-v2",
  "version": "1.0.42",
  "scripts": {
    "ng": "ng",
    "start": "node git-version.js && ng serve --port 4201",
    "build": "node git-version.js && ng build && npm run sentry:sourcemaps",
    "build-fr": "node git-version.js && ng build --configuration production_fr && npm run sentry:sourcemaps",
    "build-staging": "node git-version.js && ng build --configuration staging && npm run sentry:sourcemaps",
    "watch": "node git-version.js && ng build --watch --configuration development",
    "test": "node git-version.js && ng test",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org snapmatic --project snapmatic-frontend-v2 ./dist/snapmatic-frontend-v2/browser/ && sentry-cli --url https://sentry.analog-robot.com sourcemaps upload --org snapmatic --project snapmatic-frontend-v2 ./dist/snapmatic-frontend-v2/browser/"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@fortawesome/angular-fontawesome": "^0.14.1",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-brands-svg-icons": "^6.4.2",
    "@fortawesome/free-regular-svg-icons": "^6.4.2",
    "@fortawesome/free-solid-svg-icons": "^6.4.2",
    "@sentry/angular-ivy": "^7.100.1",
    "@sentry/cli": "^2.28.0",
    "@typeform/embed": "^5.5.0",
    "bad-words": "^4.0.0",
    "bowser": "^2.11.0",
    "date-fns": "^3.6.0",
    "flowbite": "^2.2.1",
    "git-describe": "^4.1.1",
    "hammerjs": "^2.0.8",
    "konva": "^9.3.2",
    "mime": "^4.0.1",
    "ng-recaptcha": "^13.2.1",
    "ngx-date-fns": "^11.0.0",
    "ngx-device-detector": "^7.0.0",
    "rxjs": "~7.8.0",
    "semver": "^7.6.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.1.3",
    "@angular/cli": "^17.1.3",
    "@angular/compiler-cli": "^17.1.0",
    "@angular/localize": "^17.1.3",
    "@types/hammerjs": "^2.0.45",
    "@types/jasmine": "~5.1.0",
    "@types/mime": "^3.0.4",
    "@types/semver": "^7.5.8",
    "autoprefixer": "^10.4.17",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.35",
    "tailwindcss": "^3.4.1",
    "typescript": "~5.3.2"
  }
}
